/**
 * 事業場
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/search/traders`

const search_trader_location = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    index ({ commit }, { id, mode }) {
      const api_path = `${API_PATH}/${id}/locations`
      const params = { trader_id: id, mode: mode }
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: params }).then(data => {
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}
export default search_trader_location
